module.exports = __webpack_public_path__ + "img/nrg.aa46c830.png";